import { createContext } from "react";

import DefaultClient from "src/api/client";

/**
 * Provides the shared ServiceStack client, defaulting to a client rooted at the application
 * origin.
 *
 * Postconditions: Context creation establishes the default client; consumers may override it with
 * a provider. This declaration does not itself send a request.
 */
export const ServiceStackClientContext = createContext(DefaultClient("/", undefined));

export default ServiceStackClientContext;
